import './MarketTooltip.css';const t = "_marketTooltipContainer_d129bed", o = { marketTooltipContainer: t };
export {
  o as default
};
